import SearchBootstrapTable from "app/Components/BootstrapTable/SearchBootstrapTable";
import React, { useMemo } from "react";
import { DDMMYYYYFormat } from "app/_helpers/dateHelper";
import { Button, Col, OverlayTrigger, Tooltip } from "react-bootstrap";
import SingleFileUpload from "app/views/custom/components/FileUpload/SingleFileUpload";
import FormInput from "app/Components/_form/FormInput/FormInput";
import FormSelect from "app/Components/_form/FormSelect/FormSelect";
import SimpleSelect from "app/Components/SearchableSelect/SimpleSelect";
import { FiMinusCircle, FiPlusCircle } from "react-icons/fi";
import DatePicker from "app/Components/DateTimeCustom/CustomDateTime";
import InputError from "app/Components/_form/InputError/InputError";
import {
  generatedTypeObj,
  previousTrainingLabel,
  previousTrainingObj,
} from "../Constant";
import moment from "moment";
import { getExpiryDate } from "app/_helpers/helper";

const PreviousTrainingRecord = ({
  previousTraining = [],
  setPreviousTraining,
  trainingOption,
  preTrainingErr,
}) => {
  const addRow = () =>
    setPreviousTraining((previous) => [
      ...previous,
      JSON.parse(JSON.stringify(previousTrainingObj)),
    ]);

  const deleteRow = (index) =>
    setPreviousTraining((previous) =>
      previous
        .map((data, idx) =>
          idx !== index ? data : data.id ? { ...data, deleted: 1 } : null
        )
        .filter((data) => !!data)
    );

  const onChange = ({ name, value, type, checked, index }) => {
    setPreviousTraining((prev) =>
      prev.map((data, idx) => {
        if (idx !== index) return data;

        if (name === "trainingCompletionDate") {
          let expiryDate = getExpiryDate(value, 4);
          data["trainingExpiryDate"] = expiryDate;
        }

        data[name] = type === "checkbox" ? checked : value;
        return data;
      })
    );
  };

  const onFileChange = (event, responseData, name, index) => {
    setPreviousTraining((prev) =>
      prev.map((data, idx) => {
        if (idx !== index) return data;

        data[name] = responseData?.id;
        data["file"] = responseData;
        return data;
      })
    );
  };
  const deleteDocumentFile = (_event, name, index) => {
    setPreviousTraining((prev) =>
      prev.map((data, idx) => {
        if (idx !== index) return data;
        data[name] = null;
        data["file"] = null;
        return data;
      })
    );
  };

  return (
    <div className="form-group mt-3">
      <h5 className="highlightTxt">Previous Training Record</h5>
      <div className="w-100">
        <div className="table-responsive">
          <table id="user_table" className="table table-bordered mb-3">
            <thead>
              <tr>
                <th scope="col">S.No</th>
                <th scope="col">{previousTrainingLabel.trainingDesignation}</th>
                <th scope="col">{previousTrainingLabel.trainingCompletionDate}</th>
                <th scope="col">{previousTrainingLabel.trainingExpiryDate}</th>
                <th scope="col">{previousTrainingLabel.trainingCertificateNo}</th>
                <th scope="col">{previousTrainingLabel.trainingCertificateId}</th>
                <th scope="col">Remove</th>
              </tr>
            </thead>
            <tbody>
              {previousTraining.map((x, index) => {
                return x.deleted ? null : (
                  <tr key={index}>
                    <th>{index + 1}</th>
                    <td>
                      <SimpleSelect
                        name={"trainingDesignation"}
                        value={+x?.trainingDesignation}
                        onChange={({ target: { name, value } }) =>
                          onChange({ name, value, index })
                        }
                        options={trainingOption}
                        // label={"name"}
                        // id="value"
                        placeHolder={previousTrainingLabel.trainingDesignation}
                        // menuPortalTarget={menuPortalTarget}
                        disabled={x?.trainingUpdateBy === generatedTypeObj.system}
                      />

                      <span className="small text-danger">
                        {preTrainingErr[index]?.trainingDesignation}
                      </span>
                    </td>
                    <td>
                      <DatePicker
                        name={"trainingCompletionDate"}
                        value={x.trainingCompletionDate}
                        onChangeDate={({ target: { name, value } }) =>
                          onChange({ name, value, index })
                        }
                        label={previousTrainingLabel.trainingCompletionDate}
                        placeHolder={previousTrainingLabel.trainingCompletionDate}
                        error={preTrainingErr[index]?.trainingCompletionDate}
                        disabled={x?.trainingUpdateBy === generatedTypeObj.system}
                        // isValidDate={disableFutureDate}
                      />
                      <InputError error={preTrainingErr[index]?.trainingCompletionDate} />
                    </td>
                    <td>
                      <DatePicker
                        isValidDate={(day) =>
                          day.isAfter(moment(x.trainingCompletionDate).add(-1, "days"))
                        }
                        name={"trainingExpiryDate"}
                        value={x.trainingExpiryDate}
                        onChangeDate={({ target: { name, value } }) =>
                          onChange({ name, value, index })
                        }
                        label={previousTrainingLabel.trainingExpiryDate}
                        placeHolder={previousTrainingLabel.trainingExpiryDate}
                        error={preTrainingErr[index]?.trainingExpiryDate}
                        disabled={x?.trainingUpdateBy === generatedTypeObj.system}
                        // isValidDate={disableFutureDate}
                      />
                      <InputError error={preTrainingErr[index]?.trainingExpiryDate} />
                    </td>
                    <td>
                      <FormInput
                        name={"trainingCertificateNo"}
                        type="text"
                        value={x.trainingCertificateNo}
                        onChange={({ target: { name, value } }) =>
                          onChange({ name, value, index })
                        }
                        placeHolder={previousTrainingLabel.trainingCertificateNo}
                        error={preTrainingErr[index]?.trainingCertificateNo}
                        disabled={x?.trainingUpdateBy === generatedTypeObj.system}
                      />
                    </td>
                    <td>
                      <SingleFileUpload
                        clsName="form-group"
                        alias={false}
                        name="trainingCertificateId"
                        disabled={x?.trainingUpdateBy === generatedTypeObj.system}
                        labelName=" "
                        selectedFile={x?.trainingCertificateId ? x?.file : null}
                        deleteDocumentFile={(_event, name) =>
                          deleteDocumentFile(_event, name, index)
                        }
                        onFileChange={(event, responseData, name) =>
                          onFileChange(event, responseData, name, index)
                        }
                      />
                    </td>
                    <td>
                      <div className="actionIconsGroup">
                        <OverlayTrigger
                          placement="top"
                          overlay={<Tooltip id="tooltip-top">Delete</Tooltip>}
                        >
                          <span
                            onClick={() =>
                              x?.trainingUpdateBy !== generatedTypeObj.system &&
                              deleteRow(index)
                            }
                            className="pointer icons text-danger font-20"
                          >
                            <FiMinusCircle />
                          </span>
                        </OverlayTrigger>
                      </div>
                    </td>
                  </tr>
                );
              })}
              <tr>
                <td colSpan="10">
                  <OverlayTrigger
                    placement="top"
                    overlay={<Tooltip id="tooltip-top">Add Row</Tooltip>}
                  >
                    <Button className="addRowPluseIcon" onClick={addRow}>
                      <FiPlusCircle />
                    </Button>
                  </OverlayTrigger>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default PreviousTrainingRecord;
